import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";
import { constructQueryString } from "../../helpers/Functions";

const api = new APICore();

export const connectXAccount = createAsyncThunk(
  "x/connectXAccount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CONNECT_X, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const createXPost = createAsyncThunk(
  "x/createXPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_X_POST, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getXPost = createAsyncThunk(
  "x/getXPost",
  async (data, { rejectWithValue }) => {
    try {
      const query = constructQueryString(data);
      const response = await api.get(`${Url.GET_X_POST}?${query}`);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getXAuthUrl = createAsyncThunk(
  "x/getXAuthUrl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${Url.GET_X_AUTH_URL}`
      );
      // showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getXAuthToken = createAsyncThunk(
  "x/getXAuthToken",
  async (data, { rejectWithValue }) => {
    try {
      let url;
      if (data.oauth_token && data.oauth_verifier) {
        // OAuth 1.0a flow
        url = `${Url.GET_X_AUTH_TOKEN}?oauth_token=${data.oauth_token}&oauth_verifier=${data.oauth_verifier}`;
      } else if (data.code) {
        // OAuth 2.0 flow
        url = `${Url.GET_X_AUTH_TOKEN}?code=${data.code}&state=${data.state || ''}`;
      } else {
        throw new Error('Missing required OAuth parameters');
      }
      
      const response = await api.get(url);
      showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);
